import { Modal, SlideOut } from "@dealer-center/core-components";
import type { compareToolProps } from "./interface";
import { isSlideOutConfig } from "./interface";
import { CompareToolContent } from "./useCompareToolContent";

export const CompareTool = ({
  compareFromComponent,
  compareToComponent,
  itemsToCompare,
  compareToolConfig,
  closeModal,
  title,
  hasBridgeBar
}: compareToolProps) => {
  if (isSlideOutConfig(compareToolConfig)) {
    return (
      <SlideOut
        {...compareToolConfig}
        disableEnforceFocus={true}
        hasBridgeBar={hasBridgeBar}
        header={title}
        show={true}
        onHide={closeModal}
      >
        <CompareToolContent
          compareFromComponent={compareFromComponent}
          compareToComponent={compareToComponent}
          itemsToCompare={itemsToCompare}
        />
      </SlideOut>
    );
  }
  return (
    <Modal
      {...compareToolConfig}
      disableEnforceFocus={true}
      header={title}
      show={true}
      onHide={closeModal}
    >
      <CompareToolContent
        compareFromComponent={compareFromComponent}
        compareToComponent={compareToComponent}
        itemsToCompare={itemsToCompare}
      />
    </Modal>
  );
};
